import { render, staticRenderFns } from "./ExpenseSubCategoryNew_Details.vue?vue&type=template&id=748190c2&"
import script from "./ExpenseSubCategoryNew_Details.vue?vue&type=script&lang=js&"
export * from "./ExpenseSubCategoryNew_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports